module.exports = __webpack_public_path__ + "img/5.b5978b37.png";